import { API } from '../api';
import axiosInstance from '../axiosConfig';

/**
 * Admin flow-builder persistence. `POST /flow/:locationId` is the only writer of a
 * location's booking rule (`Location.flowRule`) and of its live FlowConfig — there is
 * no separate draft on the backend, so every save here is a publish.
 */

/** @returns {Promise<import('../../flow/types').LocationFlow|null>} */
export const getLocationFlow = async (locationId) => {
  const response = await axiosInstance.get(`${API.FLOW.BASE}${locationId}`);
  return response?.data?.data ?? null;
};

/**
 * The location's booking-flow flags and the blocks they enable.
 * @returns {Promise<import('../../flow/types').FlowBuilderRules>}
 */
export const getFlowBuilderRules = async (locationId) => {
  const response = await axiosInstance.get(`${API.FLOW.BASE}${locationId}/rules`);
  return response?.data?.data;
};

/**
 * `flags` are the source of truth; `rule` is still required by the backend
 * (legacy) and derived from them.
 * @param {number} locationId
 * @param {{ rule: 1|2|3, config: import('../../flow/types').FlowConfig|null, flags?: import('../../flow/types').BookingFlowFlags }} body
 * @returns {Promise<import('../../flow/types').LocationFlow>}
 */
export const saveLocationFlow = async (locationId, body) => {
  const response = await axiosInstance.post(`${API.FLOW.BASE}${locationId}`, body);
  return response?.data?.data;
};

/** @returns {Promise<{ slug: string }>} */
export const generateLocationSlug = async (locationId) => {
  const response = await axiosInstance.post(`${API.FLOW.BASE}${locationId}/slug`);
  return response?.data?.data;
};
